<!DOCTYPE html>
<html>

<head>
  <meta charset="UTF-8">
  <title>Redirection vers une page de paiement sécurisée</title>
</head>

<body>
<div class="container">
  <h1>Redirection vers une page de paiement sécurisée</h1>
  <div style="text-align: center; gap: 20px;">
    <p>Vous allez renouveler l'annonce du cheval: {{ paymentInfo.nomCheval }}</p>
    <p>Montant: {{ paymentInfo.montant | euro}}</p>
  </div>
  <app-payment-button (onPayment)="setPaymentInfo($event)"></app-payment-button>
</div>
</body>

</html>
